import React, { useEffect, useState } from 'react'
import { Route, useHistory } from 'react-router-dom'
import Header from '../Header/Header'
import { assignLanguage, clanicData } from '../../utils/helpers'
import MainFooter from '../Footer/Footer'
import { useDispatch, useSelector } from 'react-redux'
import { addAllDoctorsUser, addAllRooms, addClanicServices, addAllContactForms } from '../../Redux/actions/userActions'
import { loginUser, removeUser, } from '../../Redux/actions/authActions'

const Layout = ({ component: Component, ...rest }) => {
    const language = useSelector(state => state?.languageReducer)
    const selectedLanguage = assignLanguage(language?.language)
    const user = useSelector(state => state.authReducer.user)
    const dispatch = useDispatch()
    const userActions = {
        addClanicServices: e => dispatch(addClanicServices(e)),
        addAllDoctorsUser: e => dispatch(addAllDoctorsUser(e)),
        addAllRooms: e => dispatch(addAllRooms(e)),
        addAllContactForms: e => dispatch(addAllContactForms(e)),
    }

    useEffect(() => {
        if (user?._id) {
            clanicData.all(userActions, user?._id)
        }
    }, [])

    const authActions = {
        loginUser: e => dispatch(loginUser(e)),
        removeUser: () => dispatch(removeUser())
    }

    console.log(selectedLanguage)
    return (
        <Route {...rest} render={props => <AddMenu
            selectedLanguage={selectedLanguage}
            userActions={userActions}
            authActions={authActions}
            language={language}
            user={user}
            {...props}
            component={Component}
        />
        } />
    )
}

const AddMenu = ({ component: Component, ...props }) => {
    const { user } = props
    return (
        <div className='new-main-layout-div '>
            <div>
                <Header {...props} />
                <div className='new-main-component-screen-div'>
                    <Component {...props} />
                </div>
                <MainFooter  {...props} />
            </div>
        </div>
    )
}

export default Layout